export default __webpack_public_path__ + "justhatched-devices.bd1c6876.png";